import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class AdministratorPersonnePhysiqueList extends ShadowDOMElement {
	static className = "AdministratorPersonnePhysiqueList";
	
	static properties = {
		labelAddButton: { type: String, attribute: "label-add-button"},
		title: {type: String, attribute: "title"},
		visible: {
			type: Boolean, attribute: "visible", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};
	
	constructor() {
		super();
		this.visible = true;
		this.administrators = [];
		this.labelAddButton = "Ajouter un administrateur";
		this.title = "";
	}

	firstUpdated () {
		super.firstUpdated();
		this.addAdministrator ();
	}

	addAdministrator() {
		const adminContainer = document.createElement ("administrator-personne-physique");

		if (this.administrators.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(() => {
				this.removeAdministrator (adminContainer, deleteButtonWrapper);
			});
			this.appendChild (deleteButtonWrapper);
		}

		this.administrators.push (adminContainer);
		this.appendChild (adminContainer);
	}

	removeAdministrator (adminContainer, deleteButtonWrapper) {
		this.administrators = this.administrators.filter((admin) => admin !== adminContainer);
		this.removeChild (adminContainer);
		if (deleteButtonWrapper)
			this.removeChild(deleteButtonWrapper);
	}

	createDeleteButton(deleteHandler) {
		const deleteButtonWrapper = document.createElement ("row-wrapper");
		const deleteButton = document.createElement("button-field");
		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;
		deleteButton.addEventListener("click", deleteHandler);
		deleteButtonWrapper.appendChild(deleteButton);
		return deleteButtonWrapper;
	}

	render () {
		return html`
			<slot style="display: ${this.visible ? 'block' : 'none'};"></slot>
			<row-wrapper data-add-button="true" style="display: ${this.visible ? 'block' : 'none'};">
				<button-field @click="${this.addAdministrator}">
					<i class="fa fa-plus"></i><span>&nbsp;${this.labelAddButton}</span>
				</button-field>
			</row-wrapper>
		`;
	}
	
	isTransient (){
		return false;
	}

	getValues (){
		return {
			"count" : this.administrators.length || 1,
			... super.getValues ()
		}
	}

	setValues (values){
		while (this.administrators.length < values.count)
	        this.addAdministrator ();
		super.setValues (values);
	}
}

customElements.define("administrator-personne-physique-list", AdministratorPersonnePhysiqueList);
